// libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface TimelineProps {
    timeline: Array<{
        image?: {
            src: string
            alt?: string
        },
        year: string
        title: string
        text?: string
        milestones?: Array<{
            year: string
            text: string
        }>
    }>
}

export default function Timeline({
    timeline
}: TimelineProps) {

    const [visibleMilestones, setVisibleMilestones] = useState<{ [key: number]: boolean }>({})

    const toggleMilestones = (index: number) => {
        setVisibleMilestones((prev) => ({
            ...prev,
            [index]: !prev[index]
        }))
    }

    return (
        <Section textColor='text-dark' className='timeline'>
            <div className='grid-container'>
                {timeline.map((item, i) => (
                    <div className='grid-row' key={i}>

                        <div className='c-md-5 timeline__image-col'>
                            <div className='timeline__image'>
                                {item.image?.src && (
                                    <Image
                                        src={item.image?.src} // 550x430
                                        alt={item.image?.alt}
                                        className='cover'
                                    />
                                )}
                            </div>
                        </div>

                        <div className={clsx(
                            'c-md-7 start-md-7',
                            'timeline__texts',
                            !item.milestones && 'timeline__texts--no-milestones'
                        )}>
                            <div className='timeline__texts-wrapper'>

                                <div className='timeline__year'>

                                    <span className='line'></span>

                                    <h3 className='title-xs title'>
                                        {item.year}
                                    </h3>

                                </div>

                                <h2 className='timeline__title title-xs'>
                                    {item.title}
                                </h2>

                                {isNonWhitespaceString(item.text) && (
                                    <div className='timeline__text'>
                                        <RichText content={item.text} />
                                    </div>
                                )}

                                {item.image?.src && (
                                    <div className='timeline__image--mobile'>
                                        <Image
                                            src={item.image?.src} // 550x430
                                            alt={item.image?.alt}
                                            className='cover'
                                        />
                                    </div>
                                )}

                                {item.milestones && (
                                    <>

                                        <button
                                            className='timeline__milestones-button'
                                            onClick={() => toggleMilestones(i)}
                                        >
                                            {visibleMilestones[i] ? 'Hide milestones' : 'See milestones'}
                                            <svg width='19' height='17' viewBox='0 0 19 17' xmlns='http://www.w3.org/2000/svg'><path d='M10.75 16.33L9.34 14.91L15.09 9.16H0V7.16H15.09L9.34 1.41L10.75 0L18.91 8.16L10.75 16.33Z'/></svg>
                                        </button>

                                        <div className={clsx(
                                            'timeline__milestones',
                                            visibleMilestones[i] && 'timeline__milestones--visible'
                                        )}>
                                            <div>
                                                {item.milestones.map((milestone, i) => (
                                                    <div className='timeline__milestone' key={i}>

                                                        <h4 className='milestone-year'>

                                                            <span className='line'></span>

                                                            {milestone.year}
                                                        </h4>

                                                        <div className='milestone-text'>
                                                            <RichText content={milestone.text} />
                                                        </div>

                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </>
                                )}

                            </div> 
                        </div>
                        
                    </div>
                ))}
            </div>
        </Section>
    )
}

